import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  Dummyimage1,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
// import { useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";
import HttpClient from "../../Services/HttpClient";

const BookingList = ({ property_id }) => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? null,
    to: paginationData?.[path]?.to ?? null,
    property: property_id
      ? { value: property_id }
      : (paginationData?.[path]?.property ?? ""),
    search: paginationData?.[path]?.search ?? "",
  });

  const [optionsList, setOptionsList] = useState({
    properties: [],
  });

  const [bookingList, setBookingList] = useState([]);
  const [count, setCount] = useState(0);

  const [roomsPop, setRoomsPop] = useState(false);

  useEffect(() => {
    getProperties();
  }, []);

  useEffect(() => {
    const { search, property } = selectedFilter;
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        page: page,
        search: search,
        property: property,
      },
    }));
  }, [selectedFilter.property, selectedFilter.search, page]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getProperties = async () => {
    const res = await get(URLS.PROPERTIES_DROPDOWN);
    console.log("properties dropdown", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, properties: modifiedList }));
    }
  };

  const getList = async (pageNumber = 1) => {
    const { from, property, search, to } = selectedFilter;
    const payload = new FormData();
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (property) {
      payload.append("property", property?.value);
    }
    const res = await post(URLS.BOOKING_LIST + "?page=" + pageNumber, payload);
    console.log("booking list", res, res?.data);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.next ? pageNumber + 1 : pageNumber,
      });
      setBookingList(res?.data ?? []);
    }
  };

  const getBookedSlots = async (property, room_id, category) => {
    const res = await post(`${URLS.BOOKED_ROOMS}${property}/${room_id}/`, {
      from_date: selectedFilter.from ?? null,
      to_date: selectedFilter.to ?? null,
    });
    console.log("slots list", res);
    if (res?.status === "success") {
      setRoomsPop({ name: category, list: res?.timeslot_summary });
    }
  };
  useEffect(() => {
    setSelectedFilter((prev) => ({
      ...prev,
      from: moment().format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    }));
  }, []);

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      // {
      //   Header: "Date",
      //   accessor: "date",
      //   Cell: ({ value, row }) => {
      //     return <p className="red"> {value}</p>;
      //   },
      // },
      {
        Header: " Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.property_code}</p>
            </div>
          );
        },
      },
      {
        Header: "Booked Count",
        accessor: "booked_count",
        Cell: ({ value, row }) => {
          return <p>{value || "-"}</p>;
        },
      },
      {
        Header: "Owner",
        accessor: "owner",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.owner_code}</p>
            </div>
          );
        },
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Location",
        accessor: "location",
        Cell: ({ value, row }) => {
          return <p className="nowrap">{value}</p>;
        },
      },
      {
        Header: " Hotel Categories",
        accessor: "hotel_category",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Service Type",
        accessor: "service_type",
        Cell: ({ value, row }) => {
          return <p className="nowrap">{value}</p>;
        },
      },
      {
        Header: " Rooms Category",
        accessor: "rooms_category",
        Cell: ({ value, row }) => {
          return (
            <>
              {value?.map((item, index) => (
                <p
                  key={index}
                  onClick={() =>
                    getBookedSlots(
                      row.original?.property_id,
                      item?.room_id,
                      item?.room_category,
                    )
                  }
                  className="primary pointer"
                >
                  {item.room_category}
                </p>
              ))}
            </>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "property_id",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/booking-view", {
                    state: { type: "edit", property_id: value },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-BOOKINGS") ? [...d, action] : d;
  }, [page, selectedFilter.from, selectedFilter.to]);

  const exportExcel = async () => {
    let payload = {
      from_date: Boolean(selectedFilter.from)
        ? selectedFilter.from
        : moment().format("YYYY-MM-DD"),
      to_date: Boolean(selectedFilter.to)
        ? selectedFilter.to
        : moment().format("YYYY-MM-DD"),
    };
    try {
      let res = await HttpClient.post(URLS.DOWNLOAD_EXCEL, payload, {
        responseType: "blob",
      });
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "bookingList.xlsx"; // file name
      link.click();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("excel download failed:", error);
    }
  };

  return (
    <div>
      <Topbar header={"Booking"} />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total: {count}
      </h2>

      <div className="d-flex ac-je mt-3">
        <div className="d-flex ac-js gap-3">
          <DateRange
            fromValue={selectedFilter.from}
            toValue={selectedFilter.to}
            // toValue={moment().format("YYYY-MM-DD")}
            setFromDate={(date) => {
              handleChangeFilter("from", date);
            }}
            setToDate={(date) => {
              handleChangeFilter("to", date);
            }}
          />
          <Select
            className="location-search"
            options={optionsList.properties}
            value={selectedFilter.property}
            onChange={(e) => {
              handleChangeFilter("property", e);
            }}
            isClearable
            placeholder={"Property"}
          />
          <div className="search-input">
            <input
              onChange={(e) => {
                handleChangeFilter("search", e.target.value);
              }}
              value={selectedFilter.search}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
        </div>
      </div>
      <div className="d-flex ac-je mt-4">
        {checkPermission("CAN-VIEW-BOOKINGS") && (
          <button
            onClick={() => exportExcel()}
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
            style={{ backgroundColor: "#AE55F5" }}
          >
            {" "}
            Export
          </button>
        )}
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={bookingList}
        show={true}
      />
      {roomsPop && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {roomsPop?.name}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setRoomsPop(false);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex as-jb mt-3 w-100">
              <p className="f2 sec fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
                Slots
              </p>
              <p className="f2 sec fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
                Booked Room
              </p>
            </div>
            <div>
              {roomsPop?.list?.map((item) => {
                return (
                  <div className="bg-gray5 rounded-5 px-3 py-2 d-flex ac-jb my-3">
                    <p className="f2 sec fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
                      {item?.timeslot_name}
                    </p>
                    <p className="f2 sec fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
                      {item?.booked_count}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingList;
